<div [ngClass]="{'file-row': true, row: true, 'bg-light': oddRow, 'bg-white': !oddRow}"
     *ngIf="(twitterFileObject && twitterFileObject.isS3Object) || (linkedInFileObject && linkedInFileObject.isS3Object)">
  <div class="col-md-4 text-right">
    <p class="name" title="{{twitterFileObject.file?.name}}"
       *ngIf="twitterFileObject">{{twitterFileObject.file?.name | slice:0:50}}</p>
    <p class="name" title="{{linkedInFileObject.file?.name}}"
       *ngIf="linkedInFileObject">{{linkedInFileObject.file?.name | slice:0:50}}</p>
    <!--        <p *ngIf="twitterFileObject"-->
    <!--           [ngClass]="{'text-primary': twitterFileObject.status === FileObjectStatus.Uploading, 'text-success': twitterFileObject.status === FileObjectStatus.Uploaded, 'text-danger': twitterFileObject.status === FileObjectStatus.Failed}">-->
    <!--            <strong *ngIf="twitterFileObject.status !== FileObjectStatus.NotStarted"-->
    <!--                    [ngClass]="{'error': twitterFileObject.status === FileObjectStatus.Failed}">-->
    <!--                {{FileObjectStatus[twitterFileObject.status]}}-->
    <!--            </strong>-->
    <!--        </p>-->
    <!--        <p *ngIf="linkedInFileObject"-->
    <!--           [ngClass]="{'text-primary': linkedInFileObject.status === FileObjectStatus.Uploading, 'text-success': linkedInFileObject.status === FileObjectStatus.Uploaded, 'text-danger': linkedInFileObject.status === FileObjectStatus.Failed}">-->
    <!--            <strong *ngIf="linkedInFileObject.status !== FileObjectStatus.NotStarted"-->
    <!--                    [ngClass]="{'error': linkedInFileObject.status === FileObjectStatus.Failed}">-->
    <!--                {{FileObjectStatus[linkedInFileObject.status]}}-->
    <!--            </strong>-->
    <!--        </p>-->
    <!--        <strong class="error text-danger">{{uploadError}}</strong>-->
  </div>
  <div class="col-md-4 text-right" *ngIf="currentFileObject">
    <div class="progress" [ngClass]="{'progress-complete': isUploadComplete}">
      <div class="progress-bar"
           [ngClass]="progressBarClasses"
           role="progressbar"
           [ngStyle]="{'width': progress + '%'}"
           [attr.aria-valuenow]="progress"
           aria-valuemin="0"
            aria-valuemax="100">
        <span *ngIf="showProgressDetails && progress > 0" class="progress-bar-label">{{progressLabel}}</span>
      </div>
    </div>
    <div class="progress-footer" *ngIf="currentFileObject.file || currentFileObject.status !== FileObjectStatus.NotStarted">
      <p *ngIf="currentFileObject.file" class="size">{{currentFileObject.file.size | fileSize}}</p>
      <span *ngIf="currentFileObject.status === FileObjectStatus.Uploaded" class="upload-status uploaded">Uploaded</span>
      <span *ngIf="currentFileObject.status === FileObjectStatus.Failed" class="upload-status failed">Failed</span>
      <p *ngIf="currentFileObject.status === FileObjectStatus.Uploading" class="speed">{{speed | fileSize}}/s</p>
    </div>
  </div>
  <div class="col-md-2 text-right mt-3" *ngIf="(twitterFileObject || linkedInFileObject)">
    <i class="fa fa-remove" style="cursor: pointer; font-size: 15px; color: #6BC4E8;" (click)="clear()"
       title="remove"></i>
  </div>
</div>
